'use es6';

import { memo } from 'react';
import SkeletonBox from 'conversations-skeleton-state/components/SkeletonBox';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function CalleeNumbersSkeleton({
  phoneNumbers,
  calleeIndex
}) {
  return [...Array(phoneNumbers)].map((_item, index) => /*#__PURE__*/_jsxs("div", {
    className: "m-bottom-2",
    children: [/*#__PURE__*/_jsx(SkeletonBox, {
      width: 16,
      height: 16,
      className: "m-right-1 display-inline-block"
    }), /*#__PURE__*/_jsx(SkeletonBox, {
      width: 24,
      height: 16,
      className: "m-right-1 display-inline-block"
    }), /*#__PURE__*/_jsx(SkeletonBox, {
      width: 120,
      height: 16,
      className: "m-right-1 display-inline-block"
    }), /*#__PURE__*/_jsx(SkeletonBox, {
      width: 80,
      height: 16,
      className: "m-right-1 display-inline-block"
    })]
  }, `number-placeholder_${calleeIndex}-${index}`));
}
function CalleesSkeleton({
  showCalleeNames
}) {
  const calleeLength = showCalleeNames ? 2 : 1;
  return /*#__PURE__*/_jsx("div", {
    className: "m-top-3",
    "data-selenium-test": "callees-skeleton",
    children: [...Array(calleeLength)].map((value, index) => /*#__PURE__*/_jsxs("div", {
      className: "m-x-3 m-bottom-0",
      children: [showCalleeNames ? /*#__PURE__*/_jsx(SkeletonBox, {
        width: 152,
        height: 16,
        className: "m-bottom-4"
      }) : null, /*#__PURE__*/_jsx(CalleeNumbersSkeleton, {
        phoneNumbers: 4,
        calleeIndex: index
      })]
    }, `callee-placeholder_${index}`))
  });
}
export default /*#__PURE__*/memo(CalleesSkeleton);